import React, { useEffect, useRef, useState } from "react";
import "./landpage.css";
import { useHistory } from "react-router-dom";

// ====== DADOS (fáceis de editar) ======
// Cada banner tem a versão desktop e mobile (imagens WebP, formato leve e moderno).
const BANNERS = [
  { id: "b1", desktop: "/images/hero/topo_b1_desktop.webp", mobile: "/images/hero/topo_b1_mobile.webp" },
  { id: "b2", desktop: "/images/hero/topo_b2_desktop.webp", mobile: "/images/hero/topo_b2_mobile.webp" },
  { id: "b3", desktop: "/images/hero/topo_b3_desktop.webp", mobile: "/images/hero/topo_b3_mobile.webp" },
  { id: "b4", desktop: "/images/hero/topo_b4_desktop.webp", mobile: "/images/hero/topo_b4_mobile.webp" },
  { id: "b5", desktop: "/images/hero/topo_b5_desktop.webp", mobile: "/images/hero/topo_b5_mobile.webp" },
  { id: "b6", desktop: "/images/hero/topo_b6_desktop.webp", mobile: "/images/hero/topo_b6_mobile.webp" },
  { id: "b7", desktop: "/images/hero/topo_b7_desktop.webp", mobile: "/images/hero/topo_b7_mobile.webp" },
  { id: "b8", desktop: "/images/hero/topo_b8_desktop.webp", mobile: "/images/hero/topo_b8_mobile.webp" },
  { id: "b9", desktop: "/images/hero/topo_b9_desktop.webp", mobile: "/images/hero/topo_b9_mobile.webp" },
];

const SELOS = [
  { ic: "/icons/selos/mini_sem_anuncios.png", h: "Sem anúncios", p: "Nenhuma propaganda durante a diversão." },
  { ic: "/icons/selos/mini_100_infantil.png", h: "Ambiente 100% infantil", p: "Tudo pensado para os pequeninos." },
  { ic: "/icons/selos/mini_conteudo_seguro.png", h: "Conteúdo seguro", p: "Valores que fortalecem a fé." },
  { ic: "/icons/selos/mini_em_qualquer_tela.png", h: "Em qualquer tela", p: "TV, celular e tablet." },
];

const CAPAS = ["/images/capas_c1.webp", "/images/capas_c2.webp", "/images/capas_c3.webp"];

const BENEFICIOS = [
  { img: "/images/beneficios/beneficio_1.webp", alt: "Criança assistindo tranquila no tablet, sem anúncios", html: "Seu filho assiste <b>sem interrupções</b> e sem exposição a propagandas inadequadas." },
  { img: "/images/beneficios/beneficio_2.webp", alt: "Mãe e filho cantando juntos no sofá", html: "Histórias e músicas que <b>fortalecem valores positivos</b> e aproximam famílias." },
  { img: "/images/beneficios/beneficio_3.webp", alt: "Família assistindo JoinKids na TV, celular e tablet", html: "TV, celular, tablet ou computador. A <b>infância segura</b> acompanha sua família." },
  { img: "/images/beneficios/beneficio_4.webp", alt: "Criança pequena sorrindo com tablet em quarto infantil", html: "Uma plataforma criada <b>especialmente para crianças pequenas</b>." },
];

const DEPOIMENTOS = [
  { nome: "Fernanda Lemos", txt: '"O melhor app, fico tranquila com os conteúdos oferecidos, muita segurança para nossas crianças. Adorei!! Eu recomendo!!!"' },
  { nome: "Maryellem Amorim", txt: '"Uma benção, tem me ajudado muito aqui em casa, porque tenho a tranquilidade de trabalhar e saber que a minha filha está tendo um bom ensinamento e vendo conteúdos abençoados. Deus continue abençoando." 🙏' },
  { nome: "Filipe Jardim", txt: '"Que Deus siga cada vez mais abençoando o ministério de vcs. O melhor investimento para meus filhos é esse!"' },
  { nome: "May Macedo Sol Posto", txt: '"Estou gostando bastante, são bem atenciosos, auxiliam em qualquer dúvida, ótimos conteúdos." 👏🙏' },
  { nome: "Lucielle Noronha", txt: '"App MT colorido, MT bonito! Desenhos e música que servem pra TDS as idades, podem deixar qlqr criança assistindo sem medo!!! Que Deus abençoe TD a equipe por trás de TD isso!! Super recomendo!"' },
  { nome: "Jaqueline Castro", txt: '"O APP é bonito, organizado e bem colorido! 😀 Bastante musical, educativo e tudo voltado para cristãos. Os organizadores são educados, simpáticos, respondem rapidamente às dúvidas. Atendimento excelente!"' },
  { nome: "Arlete Lemos", txt: '"Gostei muito. É fácil de acessar, os conteúdos são adequados para nossas crianças."' },
  { nome: "Aldenora Souza", txt: '"Perfeito para nossas crianças."' },
];

const FAQ_FIXAS = [
  { q: "Quanto custa e quais são os planos?", a: "São dois planos: Mensal por R$ 22,90 e Anual por R$ 178,80 (equivalente a R$ 14,90/mês, economizando R$ 81,60 no ano). Você pode cancelar quando quiser." },
  { q: "Quantas crianças podem usar ao mesmo tempo?", a: "Até 3 telas simultâneas — ideal para famílias com mais de uma criança." },
];

export default function NovaLandpage() {
  const history = useHistory();
  const go = (to) => history.push(`/${to}`);

  // ---- Detecta se é tela de celular (para escolher imagem desktop/mobile) ----
  const mq = "(max-width:760px)";
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.matchMedia(mq).matches);
  useEffect(() => {
    const onR = () => setIsMobile(window.matchMedia(mq).matches);
    window.addEventListener("resize", onR);
    return () => window.removeEventListener("resize", onR);
  }, []);

  // ---- Carrossel do HERO (troca sozinho) ----
  const [hero, setHero] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setHero((i) => (i + 1) % BANNERS.length), 5000);
    return () => clearInterval(t);
  }, []);
  const heroGo = (n) => setHero((n + BANNERS.length) % BANNERS.length);

  // Carrega a imagem de fundo SÓ dos banners já vistos (o atual e o próximo).
  // Assim a página inicial não baixa as 9 imagens de uma vez — economiza muito
  // no primeiro carregamento. As demais entram conforme o carrossel avança.
  const [heroSeen, setHeroSeen] = useState(() => new Set([0, 1]));
  useEffect(() => {
    setHeroSeen((prev) => {
      const next = new Set(prev);
      next.add(hero);
      next.add((hero + 1) % BANNERS.length);
      return next;
    });
  }, [hero]);

  // ---- Carrossel de CAPAS (de 4 em 4) ----
  const [capa, setCapa] = useState(0);
  const capaGo = (n) => setCapa((n + CAPAS.length) % CAPAS.length);

  // ---- Carrossel de DEPOIMENTOS ----
  const depoTrackRef = useRef(null);
  const [depo, setDepo] = useState(0);
  const [porVez, setPorVez] = useState(typeof window !== "undefined" && window.matchMedia("(max-width:760px)").matches ? 1 : 3);
  const maxDepo = Math.max(0, DEPOIMENTOS.length - porVez);
  useEffect(() => {
    const onResize = () => setPorVez(window.matchMedia("(max-width:760px)").matches ? 1 : 3);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  useEffect(() => { if (depo > maxDepo) setDepo(maxDepo); }, [maxDepo, depo]);
  // deslocamento por px (largura de 1 card + gap 22)
  const [depoShift, setDepoShift] = useState(0);
  useEffect(() => {
    const calc = () => {
      const track = depoTrackRef.current;
      if (!track || !track.children.length) return;
      const w = track.children[0].getBoundingClientRect().width + 22;
      setDepoShift(depo * w);
    };
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, [depo, porVez]);

  // ---- FAQ do BACKEND (atualiza sozinho) ----
  const [faqBackend, setFaqBackend] = useState({ loading: true, lista: [], erro: false });
  const [faqAberta, setFaqAberta] = useState(0); // primeira fixa aberta
  useEffect(() => {
    let vivo = true;
    fetch("https://api.joinkids.com.br/api/information", { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((data) => {
        if (!vivo) return;
        const lista = (data && (data.help || (data.data && data.data.help))) || [];
        setFaqBackend({ loading: false, lista: lista.map((it) => ({ q: it.question || it.ask || "", a: it.answer || "" })).filter((x) => x.q), erro: false });
      })
      .catch(() => vivo && setFaqBackend({ loading: false, lista: [], erro: true }));
    return () => { vivo = false; };
  }, []);

  const faqTodas = [...FAQ_FIXAS, ...faqBackend.lista];

  return (
    <div className="jk-lp">
      {/* HEADER */}
      <header className="nav">
        <div className="wrap nav-inner">
          <img className="nav-logo" src="/icons/logo.svg" alt="JoinKids" />
          <nav className="nav-links">
            <a className="navlink" href="#telas">Onde assistir</a>
            <a className="navlink" href="/conteudos">Conteúdos</a>
            <a className="navlink" href="#planos">Planos</a>
            <a className="navlink" href="#faq">Dúvidas</a>
            <div className="nav-cta">
              <button className="btn btn-ghost" onClick={() => go("login")}>Entrar</button>
              <a className="btn btn-green" style={{ fontSize: 15, padding: "10px 22px" }} href="#planos">Assinar</a>
            </div>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="hero" id="topo">
        <div className="hero-carousel">
          {BANNERS.map((b, idx) => (
            <div
              key={b.id}
              className={`slide ${b.id}${idx === hero ? " active" : ""}`}
              style={heroSeen.has(idx) ? { backgroundImage: `url('${isMobile ? b.mobile : b.desktop}')` } : undefined}
            />
          ))}
        </div>
        <div className="hero-overlay">
          <div className="wrap">
            <div className="hero-content">
              <img className="hero-logo" src="/icons/logo_joinkids_banner.png" alt="JoinKids" />
              <h1>O lugar <span className="hl">seguro</span><br />da infância.</h1>
              <p className="sub">Desenhos, músicas e histórias para crianças crescerem com alegria, valores e proteção digital.</p>
              <div className="hero-actions">
                <a className="btn btn-green" href="#planos">Quero proteger meu filho</a>
                <a className="btn btn-ghost" href="/conteudos">Ver conteúdos</a>
              </div>
              <div className="hero-trust">✓ Sem anúncios &nbsp;·&nbsp; ✓ Ambiente 100% infantil &nbsp;·&nbsp; ✓ Cancele quando quiser</div>
            </div>
          </div>
        </div>
        <button className="car-arrow prev" aria-label="Banner anterior" onClick={() => heroGo(hero - 1)}>‹</button>
        <button className="car-arrow next" aria-label="Próximo banner" onClick={() => heroGo(hero + 1)}>›</button>
        <div className="car-dots">
          {BANNERS.map((b, idx) => (
            <button key={b.id} className={idx === hero ? "on" : ""} aria-label={`Ir para o banner ${idx + 1}`} onClick={() => heroGo(idx)} />
          ))}
        </div>
      </section>

      {/* SELOS */}
      <div className="wrap">
        <div className="selos">
          {SELOS.map((s) => (
            <div className="selo" key={s.h}>
              <div className="ic"><img src={s.ic} alt="" /></div>
              <h3>{s.h}</h3><p>{s.p}</p>
            </div>
          ))}
        </div>
      </div>

      {/* TELAS / PLATAFORMAS */}
      <section className="section" id="telas">
        <div className="wrap">
          <h2 className="sec-title">A infância segura em qualquer tela</h2>
          <p className="sec-sub">Leve a JoinKids para onde a família estiver — na sala, no carro ou na hora de dormir.</p>
          <div className="two">
            <div className="telas-bloco">
              <h3 className="telas-titulo">Assista onde quiser</h3>
              <img className="telas-img" src="/images/devices.webp" alt="Disponível em Smart TV, iPad, Android e iPhone" width="960" height="315" loading="lazy" />
            </div>
            <div className="telas-bloco">
              <h3 className="telas-titulo">Disponível nas suas plataformas favoritas</h3>
              <img className="telas-img" src="/images/plataformas.webp" alt="App Store, Google Play, LG Smart TV, Samsung Smart TV, Web, Google TV e Roku" width="960" height="325" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* VITRINE */}
      <section className="section vitrine" id="conteudos">
        <div className="wrap vitrine-grid">
          <div>
            <div className="capas">
              <div className="capas-viewport">
                <div className="capas-track" style={{ transform: `translateX(-${capa * 100}%)` }}>
                  {CAPAS.map((src, idx) => (
                    <img key={src} src={src} width="1600" height="713" loading="lazy" alt={idx === 0 ? "Conteúdos JoinKids: Moda Amarela, O Amigo Perfeito, Turma da CapiMara e Super Gabi" : "Mais conteúdos JoinKids"} />
                  ))}
                </div>
              </div>
              <button className="capas-arrow prev" aria-label="Conteúdos anteriores" onClick={() => capaGo(capa - 1)}>‹</button>
              <button className="capas-arrow next" aria-label="Próximos conteúdos" onClick={() => capaGo(capa + 1)}>›</button>
              <div className="capas-dots">
                {CAPAS.map((c, idx) => (
                  <button key={c} className={idx === capa ? "on" : ""} aria-label={`Grupo de conteúdos ${idx + 1}`} onClick={() => capaGo(idx)} />
                ))}
              </div>
            </div>
          </div>
          <div>
            <h2>Cada conteúdo é pensado para crianças</h2>
            <p className="lead"><strong style={{ color: "var(--primary)", fontWeight: 700 }}>Mais de 500 vídeos</strong> entre desenhos, músicas e histórias — cada um feito especialmente para os pequeninos.</p>
            <p className="lead"><span className="nope">Sem exageros. Sem conteúdos impróprios. Sem medo do próximo vídeo.</span></p>
            <p className="lead">Apenas entretenimento seguro, divertido e cheio de valores positivos.</p>
          </div>
        </div>
      </section>

      {/* BENEFÍCIOS */}
      <section className="section">
        <div className="wrap">
          <div className="benef">
            {BENEFICIOS.map((b) => (
              <div className="item" key={b.img}>
                <div className="ph"><img src={b.img} alt={b.alt} width="640" height="640" loading="lazy" /></div>
                <p dangerouslySetInnerHTML={{ __html: b.html }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PLANOS */}
      <section className="section cta" id="planos">
        <div className="wrap center">
          <h2 className="sec-title">Comece hoje mesmo</h2>
          <p className="sec-sub">Experimente a JoinKids e transforme o momento da tela em algo leve, seguro e cheio de propósito.</p>
          <div className="plans">
            <div className="plan">
              <h3>Plano Mensal</h3>
              <div className="price">R$ 22,90<small>/mês</small></div>
              <div className="eq">flexível, cancele quando quiser</div>
              <ul>
                <li>Acesso ilimitado aos conteúdos</li>
                <li>Até 3 crianças ao mesmo tempo</li>
                <li>Cancele a qualquer momento</li>
                <li>Atividades no site para imprimir</li>
                <li>Livro digital animado para leitura</li>
              </ul>
              <button className="btn btn-secondary" onClick={() => go("register")}>Quero o mensal</button>
            </div>
            <div className="plan best">
              <div className="badge">★ ECONOMIZE R$ 81,60/ano</div>
              <h3>Plano Anual</h3>
              <div className="price">R$ 14,90<small>/mês</small></div>
              <div className="eq">R$ 178,80 à vista no ano</div>
              <ul>
                <li>Tudo do plano mensal</li>
                <li>Acesso ilimitado aos conteúdos</li>
                <li>Até 3 crianças ao mesmo tempo</li>
                <li>Atividades no site para imprimir</li>
                <li>Livro digital animado para leitura</li>
              </ul>
              <button className="btn btn-green" onClick={() => go("register")}>Quero Assinar</button>
            </div>
          </div>
          <div className="cta-botoes">
            <a className="btn btn-roxo" href="https://www.joinkids.com.br/register?provider=giftcard">Cartão Pré-pago</a>
            <a className="btn btn-ghost" style={{ color: "var(--primary)", borderColor: "var(--primary)" }} href="https://wa.me/5592982168732?text=Eu%20quero%20saber%20mais!" target="_blank" rel="noopener noreferrer">Falar no WhatsApp</a>
          </div>
        </div>
      </section>

      {/* DEPOIMENTOS */}
      <section className="section">
        <div className="wrap">
          <h2 className="sec-title">Famílias que escolheram assistir com tranquilidade</h2>
          <p className="sec-sub">Depoimentos reais de mães e pais que confiam na JoinKids.</p>
          <div className="depo-carousel">
            <div className="depo-viewport">
              <div className="depo" ref={depoTrackRef} style={{ transform: `translateX(-${depoShift}px)` }}>
                {DEPOIMENTOS.map((d) => (
                  <div className="card" key={d.nome}>
                    <div className="stars">★★★★★</div>
                    <blockquote>{d.txt}</blockquote>
                    <div className="who"><div><b>{d.nome}</b><span>Assinante JoinKids</span></div></div>
                  </div>
                ))}
              </div>
            </div>
            <button className="depo-arrow prev" aria-label="Depoimentos anteriores" onClick={() => setDepo(Math.max(0, depo - 1))}>‹</button>
            <button className="depo-arrow next" aria-label="Próximos depoimentos" onClick={() => setDepo(Math.min(maxDepo, depo + 1))}>›</button>
            <div className="depo-dots">
              {Array.from({ length: maxDepo + 1 }).map((_, idx) => (
                <button key={idx} className={idx === depo ? "on" : ""} aria-label={`Ir para depoimento ${idx + 1}`} onClick={() => setDepo(idx)} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section vitrine" id="faq">
        <div className="wrap">
          <h2 className="sec-title">Perguntas frequentes</h2>
          <p className="sec-sub">As dúvidas mais comuns das famílias.</p>
          <div className="faq">
            {faqTodas.map((item, idx) => (
              <details key={idx} open={idx === faqAberta} onToggle={(e) => { if (e.target.open) setFaqAberta(idx); }}>
                <summary>{item.q}</summary>
                <div className="ans">{item.a}</div>
              </details>
            ))}
            {faqBackend.loading && <p className="tag-note">Carregando perguntas do sistema da JoinKids…</p>}
            {faqBackend.erro && <p className="tag-note">Não foi possível carregar as dúvidas agora. Tente recarregar a página ou fale conosco no WhatsApp.</p>}
          </div>
        </div>
      </section>

      {/* RODAPÉ */}
      <footer>
        <div className="wrap">
          <div className="foot-grid">
            <div>
              <img className="foot-logo" src="/icons/logo_lancamento.svg" alt="JoinKids" />
              <p className="foot-tag">A infância segura em qualquer tela. Conteúdo cristão para os pequeninos.</p>
              <div className="social">
                <a href="https://www.instagram.com/joinkidsbrasil" target="_blank" rel="noopener noreferrer" aria-label="Instagram da JoinKids"><img src="/icons/insta.svg" alt="Instagram" /></a>
                <a href="https://www.facebook.com/joinkidsbrasil" target="_blank" rel="noopener noreferrer" aria-label="Facebook da JoinKids"><img src="/icons/face.svg" alt="Facebook" /></a>
              </div>
            </div>
            <div>
              <h4>Plataforma</h4>
              <a href="#planos">Assinar</a>
              <button className="lp-linkbtn" onClick={() => go("login")}>Entrar</button>
              <a href="#planos">Ver planos</a>
            </div>
            <div>
              <h4>Conteúdos</h4>
              <a href="/conteudos">Desenhos</a>
              <a href="/conteudos">Músicas</a>
              <a href="/conteudos">Histórias bíblicas</a>
            </div>
            <div>
              <h4>Contato</h4>
              <a href="https://wa.me/5592982168732" target="_blank" rel="noopener noreferrer">WhatsApp (92) 98216-8732</a>
              <a href="mailto:atendimento@joinkids.com.br">atendimento@joinkids.com.br</a>
              <a href="#faq">Central de ajuda</a>
            </div>
          </div>
          <div className="foot-bottom">© 2026 JoinKids. Todos os direitos reservados.</div>
        </div>
      </footer>
    </div>
  );
}
